import styled from "styled-components";
import { Form } from "formik";

export const ContainerForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  margin: 0 auto;
  padding: 2rem 1rem 4rem;
  max-width: 520px;
  min-height: 100vh;

  h2 {
    font-size: 1.6rem;
    font-weight: 800;
    color: var(--violetaOscuro);
    margin-bottom: 1.5rem;
    text-align: center;
    letter-spacing: -0.5px;
  }

  .botonReset {
    padding: 10px 20px;
    border: 2px solid var(--naranja);
    border-radius: var(--radio);
    color: var(--naranja);
    font-weight: 700;
    font-family: "Quicksand", sans-serif;
    font-size: 0.85rem;
    background-color: transparent;
    margin: 8px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--naranja);
      color: white;
    }

    &:disabled {
      border-color: var(--grisMedio);
      color: var(--grisMedio);
      cursor: not-allowed;
      &:hover {
        background-color: transparent;
      }
    }

    @media (max-width: 800px) {
      width: 95%;
      padding: 14px;
    }
  }

  @media (max-width: 800px) {
    width: 100%;
    margin-top: 180px;
    padding: 1rem 1rem 6rem;
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    width: 90%;
    margin-top: 180px;
    padding: 2rem 1rem 6rem;
  }
`;

/* Separador de sección */
export const SectionTitle = styled.div`
  width: 100%;
  max-width: 520px;
  margin: 1.8rem 0 0.8rem;
  padding: 8px 14px;
  background: linear-gradient(
    90deg,
    var(--violetaOscuro),
    var(--violetaPastelOscuro)
  );
  border-radius: var(--radio);
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;

export const ContainerInput = styled.div`
  width: 100%;
  max-width: 520px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  gap: 12px;

  label {
    font-weight: 600;
    font-size: 0.88rem;
    color: var(--grisOscuro);
    min-width: 130px;
  }

  select {
    flex: 1;
    border-radius: var(--radio);
    border: 1.5px solid #ddd;
    padding: 8px 10px;
    font-family: "Quicksand", sans-serif;
    font-size: 0.88rem;
    color: var(--grisOscuro);
    background-color: white;
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-color: var(--violetaOscuro);
      box-shadow: 0 0 0 3px rgba(76, 4, 140, 0.08);
    }
  }

  input {
    flex: 1;
    border-radius: var(--radio);
    border: 1.5px solid #ddd;
    padding: 8px 10px;
    font-family: "Quicksand", sans-serif;
    font-size: 0.88rem;
    color: var(--grisOscuro);
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-color: var(--violetaOscuro);
      box-shadow: 0 0 0 3px rgba(76, 4, 140, 0.08);
    }
  }

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 0;

    label {
      font-size: 1rem;
      font-weight: 700;
      min-width: 0;
      text-align: left;
    }

    input,
    select {
      width: 100%;
      padding: 13px 10px;
      font-size: 1rem;
    }
  }
`;

export const InputStyled = styled.input`
  flex: 1;
  border-radius: var(--radio);
  border: 1.5px solid #ddd;
  padding: 8px 10px;
  font-family: "Quicksand", sans-serif;
  font-size: 0.88rem;
  color: var(--grisOscuro);
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: var(--violetaOscuro);
    box-shadow: 0 0 0 3px rgba(76, 4, 140, 0.08);
  }
`;

export const ErrorStyled = styled.span`
  width: 100%;
  max-width: 520px;
  text-align: right;
  font-size: 0.72rem;
  color: #e74c3c;
  font-weight: 600;
  padding-right: 4px;
  margin-bottom: 2px;

  @media (max-width: 800px) {
    font-size: 0.85rem;
    text-align: left;
    padding: 0;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 520px;
  margin-top: 1.5rem;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

/* Teléfonos */
export const ContainerInputTel = styled.div`
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  padding: 0;

  label {
    font-weight: 600;
    font-size: 0.82rem;
    color: var(--grisOscuro);
    white-space: nowrap;
  }

  @media (max-width: 800px) {
    flex-wrap: wrap;
    padding: 0;
    gap: 6px;

    label {
      font-size: 1rem;
      font-weight: 700;
    }
  }
`;

export const InputStyledTel = styled.input`
  flex: 1;
  border-radius: var(--radio);
  border: 1.5px solid #ddd;
  padding: 7px 10px;
  font-family: "Quicksand", sans-serif;
  font-size: 0.85rem;

  &:focus {
    outline: none;
    border-color: var(--violetaOscuro);
    box-shadow: 0 0 0 3px rgba(76, 4, 140, 0.08);
  }

  @media (max-width: 800px) {
    padding: 12px 10px;
  }
`;

export const SelectStyledTel = styled.select`
  border-radius: var(--radio);
  border: 1.5px solid #ddd;
  padding: 7px 8px;
  font-family: "Quicksand", sans-serif;
  font-size: 0.85rem;
  width: 110px;

  &:focus {
    outline: none;
    border-color: var(--violetaOscuro);
    box-shadow: 0 0 0 3px rgba(76, 4, 140, 0.08);
  }

  @media (max-width: 800px) {
    width: 100%;
    padding: 12px 8px;
  }
`;

export const ButtonTelTrash = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  color: var(--naranja);
  background-color: transparent;
  cursor: pointer;
  transition: color 0.2s;

  svg {
    font-size: 14px;
  }

  &:hover {
    color: var(--naranjaOscuro);
  }
`;

export const ButtonTel = styled.button`
  padding: 7px 16px;
  border: 2px solid var(--violetaOscuro);
  border-radius: var(--radio);
  color: var(--violetaOscuro);
  font-weight: 700;
  font-family: "Quicksand", sans-serif;
  font-size: 0.82rem;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 4px 0 12px;

  &:hover {
    background-color: var(--violetaOscuro);
    color: white;
  }

  @media (max-width: 800px) {
    width: 60%;
    padding: 13px;
  }
`;

export const ContainerCards = styled.div`
  width: 100%;
  max-width: 520px;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  @media (max-width: 800px) {
    padding: 8px 0;
  }
`;

export const ContainerPrice = styled.div`
  width: calc(100% - 32px);
  margin: 16px;
  padding: 0;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f3ebfa 100%);
  box-shadow:
    0 1px 2px rgba(76, 4, 140, 0.06),
    0 12px 32px -10px rgba(76, 4, 140, 0.28);
  border: 1.5px solid rgba(76, 4, 140, 0.22);
  overflow: hidden;
  position: relative;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  font-feature-settings: "cv11", "ss01";
  -webkit-font-smoothing: antialiased;
  transition:
    box-shadow 0.25s ease,
    transform 0.25s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--violetaOscuro) 0%,
      var(--violeta) 50%,
      var(--naranja) 100%
    );
  }

  &:hover {
    box-shadow:
      0 2px 4px rgba(76, 4, 140, 0.06),
      0 16px 36px -10px rgba(76, 4, 140, 0.24);
  }

  > label:last-child {
    display: block;
    padding: 0 24px 16px 24px;
    color: var(--grisMedio);
    font-size: 0.72rem;
    font-style: italic;
    line-height: 1.45;
    letter-spacing: -0.005em;
  }

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const ContainerSubtotal = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px 8px 24px;

  label {
    font-family:
      "Inter",
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;
    color: var(--grisMedio);
    font-weight: 500;
    font-size: 0.82rem;
    letter-spacing: -0.005em;

    &:last-child {
      color: var(--grisOscuro);
      font-weight: 600;
      font-variant-numeric: tabular-nums;
      font-feature-settings: "tnum";
    }
  }
`;

export const ContainerTotal = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 22px 24px 12px 24px;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;

  label:first-child {
    color: var(--grisMedio);
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  label:last-child {
    color: var(--violetaOscuro);
    font-size: 1.85rem;
    font-weight: 700;
    letter-spacing: -0.03em;
    line-height: 1;
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum", "cv11";
  }
`;

export const ContainerH2 = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
`;

export const SelectStyled = styled.select`
  flex: 1;
  border-radius: var(--radio);
  border: 1.5px solid #ddd;
  padding: 8px 10px;
  font-family: "Quicksand", sans-serif;
  font-size: 0.88rem;
`;
